import tw, { styled } from 'twin.macro';

const Body = styled.div`
  ${tw`py-4 px-4 md:px-4 flex-grow overflow-y-auto overflow-x-hidden`}
  background-color: rgb(250 250 253);
`;

export default Body;
